// web/src/components/ReportCard.tsx — Home's "Your latest report" card for one live/legacy site (portal spec 17).
// Hidden until the site has a published report. Shows the headline and the first three "Your customers" lines.
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { Icon } from './Icon';
import { monthName } from './ReportView';

export function ReportCard({ siteId }: { siteId: string }) {
  const nav = useNavigate();
  const q = useQuery({ queryKey: ['reports', siteId], queryFn: () => api.listReports(siteId) });
  const r = q.data?.[0];
  if (!r) return null;
  const customers = r.doc.cards.find((c) => c.key === 'customers');
  return (
    <section className="min-w-0 rounded-lg border border-hair bg-surface p-4">
      <div className="flex items-center gap-1.5 text-xs text-muted"><Icon name="bar-chart" size={14} />Your {monthName(r.period)} report</div>
      <h2 className="mt-1 font-head text-ink">{r.doc.headline}</h2>
      {customers && (
        <ul className="mt-2 flex flex-col gap-1 text-sm">
          {customers.lines.slice(0, 3).map((l, i) => (
            <li key={`${i}-${l.label}`} className="flex justify-between gap-3">
              <span className="min-w-0 text-muted">{l.label}</span>
              <span className="shrink-0 text-right font-head text-ink">{l.value}{l.deltaText && <span className="ml-1.5 text-xs text-muted">{l.deltaText}</span>}</span>
            </li>
          ))}
        </ul>
      )}
      <button onClick={() => nav(`/reports?site=${siteId}`)} className="mt-2 inline-flex min-h-11 items-center gap-1 text-sm text-info">
        See the full report<Icon name="chevron-right" size={14} />
      </button>
    </section>
  );
}
